// TODO: данный функционал должен переехать в модуль или feature

interface IPersonRole {
  [key: string]: string;
}

export const PERSON_ROLE: IPersonRole = {
  author: "Автор",
  translator: "Переводчик",
  agent: "Агент",
  painter: "Художник",
  compiler: "Составитель",
  narrator: "Пересказчик",
  reader: "Чтец",
  performer: "Исполнитель",
  vendor: "Производитель",
  editor: "Редактор",
  actor: "Актер",
  director: "Режиссер",
  producer: "Продюсер",
  composer: "Композитор",
  sound_designer: "Звукорежиссер",
  publisher: "Издатель",
  screenwriter: "Сценарист",
  rights_holder: "Владелец прав",
  layout_artist: "Верстальщик",
  adaptation: "Адаптация",
  dialogues: "Диалоги",
  concept: "Концепция",
  review: "Отзыв",
  foreword: "Предисловие",
  afterword: "Послесловие",
  accompanists: "Аккомпаниаторы",
  citations: "Цитаты",
  annotation: "Аннотация",
  related_to: "Связывается с",
  commentator: "Комментатор",
  consultant: "Консультант",
  corrector: "Корректор",
  scientific_advisor: "Научный советник",
  probable_author: "Вероятный автор",
  designer: "Дизайнер",
  letter_recipient: "Получатель писем",
  sponsor: "Спонсор",
  photographer: "Фотограф",
  other: "Прочее",
  not_defined: "Не определено",
  chief_editor: "Главный редактор",
  member_of_editorial_board: "Член редколлегии",
  responsible_editor: "Ответственный редактор",
  co_author: "Соавтор",
  illustrator: "Иллюстратор",
  cover_designer: "Дизайнер обложки",
  lecturer: "Лектор",
  literary_processing: "Литературная обработка",
  comments: "Комментарии",
  notes: "Примечания",
  text_preparation: "Подготовка текста",
};

export const getPersonRole = (role: string): string => {
  return PERSON_ROLE[role] || "";
};
